export default {
  badge: 'Infopiste',
  open: 'Avaa',
  close: 'Sulje',
  dismiss: 'Hylkää',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Peruuta',
  },
  dataIterator: {
    noResultsText: 'Ei osumia',
    loadingText: 'Ladataan kohteita...',
  },
  dataTable: {
    itemsPerPageText: 'Rivejä sivulla:',
    ariaLabel: {
      sortDescending: ': Järjestetty laskevasti. Poista järjestäminen aktivoimalla.',
      sortAscending: ': Järjestetty nousevasti. Järjestä laskevasti aktivoimalla.',
      sortNone: ': Ei järjestetty. Järjestä nousevasti aktivoimalla.',
      activateNone: 'Aktivoi lajittelun poistamiseksi.',
      activateDescending: 'Aktivoi laskevien laskevien lajittelemiseksi.',
      activateAscending: 'Aktivoi lajitella nouseva.',
    },
    sortBy: 'Järjestä',
  },
  dataFooter: {
    itemsPerPageText: 'Kohteita sivulla:',
    itemsPerPageAll: 'Kaikki',
    nextPage: 'Seuraava sivu',
    prevPage: 'Edellinen sivu',
    firstPage: 'Ensimmäinen sivu',
    lastPage: 'Viimeinen sivu',
    pageText: '{0}-{1} ({2})',
  },
  dateRangeInput: {
    divider: '–',
  },
  datePicker: {
    itemsSelected: '{0} valittu',
    range: {
      title: 'Valitse päivämäärät',
      header: 'Syötä päivämäärät',
    },
    title: 'Valitse päivämäärä',
    header: 'Syötä päivämäärä',
    input: {
      placeholder: 'Syötä päivämäärä',
    },
  },
  noDataText: 'Ei dataa',
  carousel: {
    prev: 'Edellinen kuva',
    next: 'Seuraava kuva',
    ariaLabel: {
      delimiter: 'Karusellin kuva {0}/{1}',
    },
  },
  calendar: {
    moreEvents: '{0} lisää',
    today: 'Tänään',
  },
  input: {
    clear: 'Tyhjennä {0}',
    prependAction: '{0} edeltävä toiminto',
    appendAction: '{0} lisätty toiminto',
    otp: 'Syötä OTP-merkki {0}',
  },
  fileInput: {
    counter: '{0} tiedostoa',
    counterSize: '{0} tiedostoa ({1} yhteensä)',
  },
  fileUpload: {
    title: 'Vedä ja pudota tiedostot tähän',
    divider: 'tai',
    browse: 'Selaa tiedostoja',
  },
  timePicker: {
    am: 'ap.',
    pm: 'ip.',
    title: 'Valitse aika',
  },
  pagination: {
    ariaLabel: {
      root: 'Sivutuksen navigointi',
      next: 'Seuraava sivu',
      previous: 'Edellinen sivu',
      page: 'Mene sivulle {0}',
      currentPage: 'Nykyinen sivu, Sivu {0}',
      first: 'Ensimmäinen sivu',
      last: 'Viimeinen sivu',
    },
  },
  stepper: {
    next: 'Seuraava',
    prev: 'Edellinen',
  },
  rating: {
    ariaLabel: {
      item: 'Luokitus {0}/{1}',
    },
  },
  loading: 'Ladataan...',
  infiniteScroll: {
    loadMore: 'Lataa lisää',
    empty: 'Ei enempää',
  },
  rules: {
    required: 'Tämä kenttä on pakollinen',
    email: 'Anna kelvollinen sähköpostiosoite',
    number: 'Tämä kenttä voi sisältää vain numeroita',
    integer: 'Tämä kenttä voi sisältää vain kokonaislukuja',
    capital: 'Tämä kenttä voi sisältää vain isoja kirjaimia',
    maxLength: 'Sinun tulee syöttää enintään {0} merkkiä',
    minLength: 'Sinun tulee syöttää vähintään {0} merkkiä',
    strictLength: 'Syötetyn kentän pituus on virheellinen',
    exclude: 'Merkki {0} ei ole sallittu',
    notEmpty: 'Valitse ainakin yksi arvo',
    pattern: 'Virheellinen muoto',
  },
}
